import { render, staticRenderFns } from "./SnmpTrap.vue?vue&type=template&id=51c215a8&"
import script from "./SnmpTrap.vue?vue&type=script&lang=js&"
export * from "./SnmpTrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports